export default __webpack_public_path__ + "static/media/x2.e2b47727.png";